<template>
    <div class="flex justify-content-end mb-4">
        <Button @click="visible = true" class="mt-3 mr-3" label="Adicionar Aulas" size="small" icon="pi pi-plus"  />
        <Button class="ml-0 mt-3 " label="Excluir Aulas" icon="pi pi-trash" severity="danger" size="small"
            :disabled="aulasSelecionadas.length == 0" @click="excluirAulas" />
    </div>

    <template>
      <Dialog v-model:visible="visible" modal header="Adicionar aulas" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <form @submit.prevent="modoEdicao ? atualizarAula() : inserirAula()">
          <Dropdown optionLabel="label" :options="cursos" optionValue="id" placeholder="Curso" v-model="novaAula.curso" required class="w-full mb-3 mt-1" />
      


          <div class="flex justify-content-between">

            <Button :label="modoEdicao ? 'Atualizar' : 'Inserir'" type="submit" :disabled="!novaAula.curso" :loading="btnLoadingAdd" autofocus />

          </div>
        </form>
      </Dialog>
    </template>


    <DataTable v-if="aulas.length > 0" :value="aulas" paginator :rows="10" dataKey="id" stripedRows v-model:selection="aulasSelecionadas" v-model:editingRows="editingRows">
        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
        <Column field="curso" header="Curso" sortable>
            <template #body="slotProps">
                {{ slotProps.data.curso_nome }}
            </template>
        </Column>

        <!-- Coluna de ação para abrir o modal -->
        <Column header="Ações" bodyStyle="text-align:center">
            <template #body="slotProps">
                <Button label="Editar" icon="pi pi-pencil" @click="abrirModalAtualizarAula(slotProps.data)" class="p-button-text" />
            </template>
        </Column>
    </DataTable>

</template>


<script setup>
import { ref, onMounted, defineProps } from 'vue'
import { useStore } from 'vuex'
import { supabase } from '@/supabase'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'

const store = useStore()
const props = defineProps({
    turma: {
        type: Number,
        default: null
    },
    ano: {
        type: String,
        default: null
    }
});

const ano = ref(props.ano)
const turma = ref(props.turma)
const btnLoadingAdd = ref(false)
const cursos = ref([])
const aulas = ref([])
const aulasSelecionadas = ref([])
const visible = ref(false)
const editingRows = ref([])
const modoEdicao = ref(false);

const novaAula = ref({
    turma: turma.value,
    curso: null
});





function abrirModalAtualizarAula(aula = null) {
    visible.value = true;
    if (aula) {
        modoEdicao.value = true;
        novaAula.value = { ...aula };
    } else {
        modoEdicao.value = false;
        novaAula.value = {
            turma: turma.value,
            curso: null
        };
    }
}



onMounted(() => {
    listarCursos()
    listarAulas()
})

const listarAulas = async () => {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('aulas')
        .select(`
            id, 
            curso, 
            cursos ( 
                disciplinas (nome), 
                anos_letivos (ano)
            )
        `)
        .eq('turma', turma.value)
        .order('id', { ascending: false });

    if (error) {
        
        store.dispatch('updateLoading', false);
        return;
    }

    

    if (data) {
        let array = data.map(item => {
            return {
                id: item.id,
                curso: item.curso,
                curso_nome: item.cursos?.disciplinas?.nome + " " + item.cursos?.anos_letivos?.ano

            };
        });
        console.log(array)
        aulas.value = array;
        store.dispatch('updateLoading', false);
    }
}


const listarCursos = async () => {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('cursos')
        .select('id, anoDoEnsinoMedio, disciplinas (id, nome), anos_letivos!inner(id,ano)')
        .eq('anoDoEnsinoMedio', ano.value)
        .gte('anos_letivos.ano', anoAtual())

    if (data) {
        let aulas = []
        data.forEach(item => aulas.push({ id: item.id, label: item.disciplinas.nome + " " + item.anos_letivos.ano }))
        cursos.value = aulas
    }
    store.dispatch('updateLoading', false)
}

const inserirAula = async () => {
    btnLoadingAdd.value = true
    store.dispatch("updateLoading", true)

    // Inserir apenas o ID do curso na tabela 'aulas'
    const { data: aulaInserida, error: erroAula } = await supabase
        .from('aulas')
        .insert([{ curso: novaAula.value.curso, turma: novaAula.value.turma }])
        .select()
    if (erroAula) {
        btnLoadingAdd.value = false
        store.dispatch("updateLoading", false)
        return
    }

    novaAula.value = { turma: turma.value, curso: null}
    btnLoadingAdd.value = false
    store.dispatch("updateLoading", false)
    listarAulas()
}


function anoAtual() {
    let dataAtual = new Date();
    return dataAtual.getFullYear();
}

const onRowEditSave = async (event) => {
    store.dispatch("updateLoading", true)
    let { newData } = event
    delete newData.curso_nome
    const { error, data } = await supabase
        .from('aulas')
        .update(newData)
        .eq('id', newData.id)
        .select()

    if (error) {
        store.dispatch("updateLoading", false)
        return
    }

    listarAulas()
}

const excluirAulas = async () => {
    store.dispatch("updateLoading", true);
    let aulasParaDeletar = aulasSelecionadas.value.map(item => item.id);

    const { error: erroExclusaoAulas } = await supabase
        .from('aulas')
        .delete()
        .in('id', aulasParaDeletar);

    if (erroExclusaoAulas) {
        store.dispatch("updateLoading", false);
        return;
    }

    listarAulas();
    aulasSelecionadas.value = [];
}


const atualizarAula = async () => {
    btnLoadingAdd.value = true
    store.dispatch("updateLoading", true)

    const { error: erroAtualizacaoAula } = await supabase
        .from('aulas')
        .update({ curso: novaAula.value.curso, turma: novaAula.value.turma })
        .eq('id', novaAula.value.id)

    if (erroAtualizacaoAula) {
        alert('Erro ao atualizar a aula')
        btnLoadingAdd.value = false
        store.dispatch("updateLoading", false)
        return
    }

    btnLoadingAdd.value = false
    store.dispatch("updateLoading", false)
    novaAula.value = { turma: turma.value, curso: null }
    listarAulas()
}


</script>